// ==============================================================

// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// function Protected(props) {
//   const { Component, requiredRole } = props;
//   const navigate = useNavigate();

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const role = localStorage.getItem("role");

//     if (!token) {
//       navigate("/");
//     } else if (requiredRole && role !== requiredRole) {
//       navigate("/dashboard");
//     }
//   }, [requiredRole, navigate]);

//   return <Component />;
// }

// export default Protected;
// =============================================================

// import React, { useEffect, useState } from "react";
// import { Navigate, useLocation } from "react-router-dom";

// function Protected({ Component, requiredRole }) {
//   const [authChecked, setAuthChecked] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userRole, setUserRole] = useState(null);
//   const location = useLocation();

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const role = localStorage.getItem("role");

//     if (token) {
//       setIsLoggedIn(true);
//       setUserRole(role);
//     } else {
//       setIsLoggedIn(false);
//     }

//     setAuthChecked(true); // auth check ho gaya
//   }, []);

//   // jab tak auth check ho raha hai -> kuch bhi render mat karo
//   if (!authChecked) {
//     return null; // ya <div className="splash">Loading...</div>
//   }

//   // agar login nahi hai
//   if (!isLoggedIn) {
//     if (
//       location.pathname === "/" ||
//       location.pathname === "/signup" ||
//       location.pathname.startsWith("/forgot-password") ||
//       location.pathname.startsWith("/reset-password")
//     ) {
//       return <Component />;
//     } else {
//       return <Navigate to="/" replace />;
//     }
//   }

//   // agar login hai
//   if (
//     location.pathname === "/" ||
//     location.pathname === "/signup" ||
//     location.pathname.startsWith("/forgot-password") ||
//     location.pathname.startsWith("/reset-password")
//   ) {
//     return <Navigate to="/dashboard" replace />;
//   }

//   // role mismatch
//   if (requiredRole && userRole !== requiredRole) {
//     return <Navigate to="/dashboard" replace />;
//   }

//   return <Component />;
// }

// export default Protected;

// ==============================================================

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Protected({ Component, requiredRole, isPublic = false }) {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (isPublic) {
      // Public route (Login, SignUp, etc.)
      if (token) {
        navigate("/dashboard"); // Already logged in → redirect to dashboard
      }
    } else {
      // Private route (Dashboard, Contacts, etc.)
      if (!token) {
        navigate("/"); // Not logged in → redirect to login
      } else if (requiredRole && role !== requiredRole) {
        navigate("/dashboard"); // Role restricted → redirect to dashboard
      }
    }
  }, [isPublic, requiredRole, navigate]);

  return <Component />;
}

export default Protected;
